import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap/modal';
import { HistoricalValuesModalComponent } from '../historical-values-modal/historical-values-modal.component';
import { ModalClass } from '@evorait/pace-core';

@Component({
    selector: 'pace-forms-history-button',
    templateUrl: './history-button.component.html',
    styleUrl: './history-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HistoryButtonComponent {
    private readonly store = inject(Store);
    @Input()
    public uniqueId: string;
    private readonly modalService = inject(BsModalService);

    public onHistoryButtonClick(): void {
        this.modalService.show(HistoricalValuesModalComponent, {
            backdrop: 'static',
            class: ModalClass.MODAL_MEDIUM,
            initialState: {
                uniqueId: this.uniqueId,
            },
            ariaLabelledBy: 'loading-screen-modal-title',
        });
    }
}
